import { PinModalKeys } from "components/PinModal/queryKeys";
import { useTypedQuery } from "hooks";
import { ApiInstance } from "utils/Api";

import type { PinDropdownOptions } from "components/PinModal/queryKeys";

const getPinDropdownOptions = (options: PinDropdownOptions) => ({
  pin_order_statuses: options.pin_order_statuses?.map(element => ({ ...element, label: `v8_${element.name}` })) || [],
  pin_statuses: options.pin_statuses?.map(element => ({ ...element, label: `v8_${element.name}` })) || [],
  pin_types: options.pin_types?.map(element => ({ ...element, label: `v8_${element.name}` })) || [],
  warranty_types: options.warranty_types?.map(element => ({ ...element, label: `v8_${element.name}` })) || []
});

export const usePinOptions = () => {
  const query = useTypedQuery({
    queryKey: PinModalKeys.dropdownsOptions,
    queryFn: ({ baseUrl, endpoint }) => ApiInstance.get(endpoint, baseUrl).then(res => res.data.pin_options),
    select: getPinDropdownOptions
  });

  return { pinOptions: query.data, isLoading: query.isFetching, error: query.error };
};
